/**
 * @flow
 * @relayHash 03c5b6befac54e9353358ebe0b41b0fd
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SongProvider = "SPOTIFY" | "%future added value";
export type CreatePlannerPlaylistSongInput = {
  clientMutationId?: ?string,
  planner_playlist_id: string,
  name: string,
  artist?: ?string,
  album?: ?string,
  isrc?: ?string,
  duration_ms?: ?number,
  external_data?: ?string,
  external_source?: ?SongProvider,
  external_id?: ?string,
  position?: ?number,
  song_images?: ?$ReadOnlyArray<?SongImageInput>,
};
export type SongImageInput = {
  url: string,
  width: number,
  height: number,
};
export type PlannerPlaylist_createPlannerPlaylistSongMutationVariables = {|
  input: CreatePlannerPlaylistSongInput
|};
export type PlannerPlaylist_createPlannerPlaylistSongMutationResponse = {|
  +createPlannerPlaylistSong: ?{|
    +new_planner_playlist_song_edge: ?{|
      +node: ?{|
        +id: string,
        +position: ?number,
        +song: ?{|
          +id: string,
          +isrc: ?string,
          +name: ?string,
          +artist: ?string,
          +album: ?string,
          +song_images: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +url: ?string,
                +width: ?number,
                +height: ?number,
              |}
            |}>
          |},
        |},
      |}
    |},
    +planner_playlist: ?{|
      +thumbnail: ?{|
        +id: string,
        +width: ?number,
        +height: ?number,
      |}
    |},
  |}
|};
export type PlannerPlaylist_createPlannerPlaylistSongMutation = {|
  variables: PlannerPlaylist_createPlannerPlaylistSongMutationVariables,
  response: PlannerPlaylist_createPlannerPlaylistSongMutationResponse,
|};
*/


/*
mutation PlannerPlaylist_createPlannerPlaylistSongMutation(
  $input: CreatePlannerPlaylistSongInput!
) {
  createPlannerPlaylistSong(input: $input) {
    new_planner_playlist_song_edge {
      node {
        id
        position
        song {
          __typename
          id
          isrc
          name
          artist
          album
          song_images {
            edges {
              node {
                url
                width
                height
                id
              }
            }
          }
        }
      }
    }
    planner_playlist {
      thumbnail(width: 240, height: 240) {
        id
        width
        height
      }
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreatePlannerPlaylistSongInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CreatePlannerPlaylistSongInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "position",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isrc",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "artist",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "album",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "width",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "height",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "thumbnail",
  "storageKey": "thumbnail(height:240,width:240)",
  "args": [
    {
      "kind": "Literal",
      "name": "height",
      "value": 240,
      "type": "Int"
    },
    {
      "kind": "Literal",
      "name": "width",
      "value": 240,
      "type": "Int"
    }
  ],
  "concreteType": "SongImage",
  "plural": false,
  "selections": [
    v2,
    v9,
    v10
  ]
};
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "PlannerPlaylist_createPlannerPlaylistSongMutation",
  "id": null,
  "text": "mutation PlannerPlaylist_createPlannerPlaylistSongMutation(\n  $input: CreatePlannerPlaylistSongInput!\n) {\n  createPlannerPlaylistSong(input: $input) {\n    new_planner_playlist_song_edge {\n      node {\n        id\n        position\n        song {\n          __typename\n          id\n          isrc\n          name\n          artist\n          album\n          song_images {\n            edges {\n              node {\n                url\n                width\n                height\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n    planner_playlist {\n      thumbnail(width: 240, height: 240) {\n        id\n        width\n        height\n      }\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "PlannerPlaylist_createPlannerPlaylistSongMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "createPlannerPlaylistSong",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreatePlannerPlaylistSongPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "new_planner_playlist_song_edge",
            "storageKey": null,
            "args": null,
            "concreteType": "PlannerPlaylistSongEdge",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "PlannerPlaylistSong",
                "plural": false,
                "selections": [
                  v2,
                  v3,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "song",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": false,
                    "selections": [
                      v2,
                      v4,
                      v5,
                      v6,
                      v7,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "song_images",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SongImageConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "SongImageEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "SongImage",
                                "plural": false,
                                "selections": [
                                  v8,
                                  v9,
                                  v10
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "planner_playlist",
            "storageKey": null,
            "args": null,
            "concreteType": "PlannerPlaylist",
            "plural": false,
            "selections": [
              v11
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "PlannerPlaylist_createPlannerPlaylistSongMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "createPlannerPlaylistSong",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreatePlannerPlaylistSongPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "new_planner_playlist_song_edge",
            "storageKey": null,
            "args": null,
            "concreteType": "PlannerPlaylistSongEdge",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "PlannerPlaylistSong",
                "plural": false,
                "selections": [
                  v2,
                  v3,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "song",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "__typename",
                        "args": null,
                        "storageKey": null
                      },
                      v2,
                      v4,
                      v5,
                      v6,
                      v7,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "song_images",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SongImageConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "SongImageEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "SongImage",
                                "plural": false,
                                "selections": [
                                  v8,
                                  v9,
                                  v10,
                                  v2
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "planner_playlist",
            "storageKey": null,
            "args": null,
            "concreteType": "PlannerPlaylist",
            "plural": false,
            "selections": [
              v11,
              v2
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2e5157c8651beb14689e82c37541ade9';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Document/MusicPlanner/__generated__/PlannerPlaylist_createPlannerPlaylistSongMutation.graphql.js